
// This is needed to get jest unit tests run.
// TODO: Fix jest unit tests and remove this import.
import AppImage from '~/components/app/app__image/app__image.vue'
import { TranslationMixin } from '~/mixins'

export default {
  name: 'SectionProjectDetails',
  components: { AppImage },
  mixins: [TranslationMixin],
  props: {
    item: {
      type: Object,
      required: true,
      project_id: {
        type: Object,
        required: true,
        id: {
          type: String,
          required: true
        },
        image: {
          type: Object,
          filename_disk: {
            type: String,
            required: true
          }
        },
        un_goals: {
          type: Object,
          id: {
            type: String,
            required: true
          },
          image: {
            type: Object,
            filename_disk: {
              type: String,
              required: true
            }
          },
          translations: {
            type: Object,
            required: true,
            name: {
              type: String,
              required: true
            }
          }
        },
        translations: {
          type: Object,
          required: true,
          name: {
            type: String,
            required: true
          },
          certified_by: {
            type: String,
            required: true
          },
          certificate_name: {
            type: String,
            required: true
          }
        }
      },
      translation: {
        type: Object,
        required: true,
        un_goals_headline: {
          type: String
        }
      }
    }
  },
  computed: {
    projectTranslation() {
      return this.getTranslation(this.item.project_id.translations)
    },
    sectionTranslation() {
      return this.getTranslation(this.item.translations)
    }
  },
  methods: {
    unGoalDescription(unGoalAssociation) {
      return (
        this.getTranslation(unGoalAssociation.translations)?.description ||
        this.getTranslation(unGoalAssociation.un_goals_id.translations).name
      )
    }
  }
}
